import { render, staticRenderFns } from "./JVxeTextareaCell.vue?vue&type=template&id=21833ba8&scoped=true"
import script from "./JVxeTextareaCell.vue?vue&type=script&lang=js"
export * from "./JVxeTextareaCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21833ba8",
  null
  
)

export default component.exports